<template>
  <div id="app">
    <HederView></HederView>
    <div class="page-content" style="flex: 1;">
      <router-view />
    </div>
    <footerView></footerView>
    <el-backtop :bottom="100">
      <div style="
        height: 100%;
        width: 100%;
        background-color: var(--el-bg-color-overlay);
        box-shadow: var(--el-box-shadow-lighter);
        text-align: center;
        line-height: 40px;
        color: #1989fa;
      ">
        UP
      </div>
    </el-backtop>
  </div>
</template>

<script>
import HederView from "@/components/Header"
import footerView from "@/components/Footer"
export default {
  components: {
    HederView,
    footerView
  },
}
</script>

<style lang="scss">
body,
html {
  margin: 0px;
  padding: 0px;
  scrollbar-width: none;
  /* 隐藏垂直滚动条 */
  -ms-overflow-style: none;
  /* 隐藏IE/Edge浏览器的垂直滚动条 */
}

/* 设置最外层容器的高度 */
.scroll-container {
  height: 500px;
  overflow-y: scroll;
  /* 自动出现滚动条 */
}

#app {
  font-family: MicrosoftYaHei;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  display: flex;
  flex-direction: column;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
